<template>
  <div class="dashboard__view">
    <div class="list">
      <div class="tab__content" style="padding: 20px 0">
        <div class="tab__content__top">
          <div class="tab__content__top__left">Active Liens</div>
        </div>
        <EmptyState v-if="!lienList.length" type="not-found" icon="audit" />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="loading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
              <tr>
                <th style="height: 50px; padding-bottom: 20px">MERCHANT</th>
                <th style="height: 50px; padding-bottom: 20px">AMOUNT</th>
                <th style="height: 50px; padding-bottom: 20px">REASON</th>
                <th
                  style="height: 50px; padding-bottom: 20px; text-align: left"
                >
                  DATE
                </th>
                <th
                  style="height: 50px; padding-bottom: 20px; text-align: left"
                >
                  ACTION
                </th>
              </tr>
            </thead>
            <tbody>
              <tr :key="key" v-for="(item, key) in lienList">
                <td>{{ item.merchant.business_name }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.reason }}</td>
                <td style="text-align: left">{{ item.createdAt | date }}</td>
                <td style="text-align: left">
                  <button
                    class="btn btn--primary"
                    @click.prevent="() => removeLien(item.merchant_id)"
                  >
                    Remove Lien
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Pagination from "@/components/pagination.vue";
import emptyTransactions from "../../../components/emptytransactions";
import EmptyState from "@/components/empty-state.vue";

export default {
  metaInfo: {
    title: "Audit Trail",
  },
  data() {
    return {
      lienList: [],
      loading: true,
      emptyState: false,
    };
  },

  created() {
    this.fetchLiens();
  },

  components: {
    Datepicker,
    emptyTransactions,
    Pagination,
    EmptyState,
  },
  methods: {
    fetchLiens() {
      this.$http
        .get(`dashboard/admin/lien`)
        .then((response) => {
          if (response.body.data.length > 0) {
            this.lienList = response.body.data;
            this.loading = false;
          } else {
            this.loading = false;
            this.auditList = "";
            this.cursor = null;
          }
        })
        .catch((error) => {
          // LOG Error
        });
    },
    async removeLien(merchantId) {
      this.loading = true;
      await this.$store.dispatch("adminRemoveLien", {
        merchantId,
      });
      this.fetchLiens();
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// filter styles start
.relative {
  position: relative;
}

.rotate {
  transform: rotate(180deg);
}

.woven-color {
  background: #e00b5b;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 40px;

  svg {
    margin-right: 5px;
  }

  .btn--text {
    font-style: normal;
    font-weight: 500;
    color: #fff;
    width: 100%;
    text-align: center;
  }
}

.pagination-view {
  width: 65%;
  display: flex;
}

.woven-border-only {
  background: #fff;
  border: 1px solid #e00b5b;
  height: 40px;

  svg {
    margin-left: 5px;
  }

  .btn--text {
    font-style: normal;
    font-weight: 500;
    text-align: center;
    color: #e00b5b;
  }
}

.filter-dropdown {
  background: #fff;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 30px;
  z-index: 100;
  left: 145px;

  .form__item {
    margin-bottom: 16px;
  }
}

.woven-red {
  color: #e00b5b;
}

.button-group {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  margin-top: 32px;
  border-top: 1px solid rgba(196, 196, 196, 0.5);

  p {
    width: 100%;
  }

  .btn {
    width: 100px;
    height: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 10px;
    text-align: center;
  }
}

.date-group {
  display: flex;
}

.margin-right {
  margin-right: 16px;
}

.date {
  border: 0.5px solid rgba(97, 110, 124, 0.5);
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(97, 110, 124, 0.8);
  padding: 12px 10px;
  max-width: 112px;
}

.status-element {
  display: flex;

  svg {
    margin-right: 10px;
    cursor: pointer;
  }
}

.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;

  span {
    color: #e00b5b;
    cursor: pointer;
  }
}

.filter-title {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 14px;
  color: #9a9fa3;
  margin-bottom: 16px;
}

// filter styles end

.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    color: #e00b5b;
    cursor: pointer;
  }
}
.btn-filter {
  height: 50px;

  border: 1px solid #fd8387;
  box-sizing: border-box;
  border-radius: 4px;
  background: transparent !important;
}
</style>

<style lang="scss" scoped>
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    color: #e00b5b;
    cursor: pointer;
  }
}
</style>
